import { useEffect, useState } from "react";
import { getToken } from "@/lib/api";

const PREFIX = "help_chat_";
const EMPTY = { messages: [], context: null };

const keyFor = (uid) => `${PREFIX}${uid}_${(getToken() || "").slice(-16)}`;

function read(key) {
  Object.keys(sessionStorage).filter((k) => k.startsWith(PREFIX) && k !== key).forEach((k) => sessionStorage.removeItem(k));
  try {
    return JSON.parse(sessionStorage.getItem(key)) || EMPTY;
  } catch {
    return EMPTY;
  }
}

export function useHelpChat(uid) {
  const [key] = useState(() => keyFor(uid));
  const [chat, setChat] = useState(() => read(key));
  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify({ ...chat, messages: chat.messages.slice(-60) }));
  }, [key, chat]);
  return [chat, setChat];
}
